// style/button.js
export const sizes = {
	sm: 'px-2 py-1 rounded text-sm',
	md: 'px-3 py-1 rounded',
	lg: 'px-4 py-2 rounded-lg',
};

export const variantClasses = {
	add: 'bg-green-600 hover:bg-green-700 text-white',
	main: 'bg-blue-600 hover:bg-blue-700 text-white',
	delete: 'bg-red-600 hover:bg-red-700 text-white',
	secondary: 'bg-gray-300 hover:bg-gray-400 text-black',
};
